import { FilePreviewAccessEnum, IFilePreview } from "tir-pm-file-preview";

/**
 * * Модель превью файла
 */
export class PreviewFileModel implements IFilePreview {
  /**ID файла */
  FileId!: number;
  /**Ссылка на файл */
  Url!: string;
  /**Ссылка на превью видео */
  VideoPreviewUrl?: string;
  /**Название файла */
  Name!: string;
  /**Размер файла (в байтах) */
  Size!: number;
  /**Дата загрузки */
  DateUpload!: Date;
  /**Пользователь загрузивший файл */
  User!: {
    /**ID */
    Id: number;
    /**Имя */
    FirstName: string;
    /**Фамилия */
    LastName: string;
    /**Отчество */
    MiddleName: string;
    /**Цвет аватарки */
    AvatarColor: string;
    /**Изображение */
    Image: string;
  };
  /**Доступы */
  Accesses: FilePreviewAccessEnum[] = [
    FilePreviewAccessEnum.Edit,
    FilePreviewAccessEnum.Remove,
  ];
  /**Прогресс загрузки */
  Progress?: number;
  /**В обработке */
  IsProccessing?: boolean;

  constructor(obj?: Partial<PreviewFileModel>) {
    Object.assign(this, obj);
  }
}
